/** Compare amounts in minor units (pence) to avoid float errors (e.g. 3.57 vs 3.569999). */
export function toMinorUnits(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100);
}

/** GBP (or 2dp currency) amount rounded to pence — use for display and withdraw caps. */
export function toMajorUnits(minorUnits) {
  const minor = Number(minorUnits);
  if (!Number.isFinite(minor)) return 0;
  return minor / 100;
}

export function roundMoneyMajor(amount) {
  return toMajorUnits(toMinorUnits(amount));
}

export function exceedsBalance(amount, balance) {
  return toMinorUnits(amount) > toMinorUnits(balance);
}

/** Largest amount safe to withdraw without exceeding stored balance (pence-accurate). */
export function maxWithdrawableAmount(balance) {
  const minor = toMinorUnits(balance);
  if (minor <= 0) return 0;
  return toMajorUnits(minor);
}
